import { createContext } from 'react';
export const ComposerPluginContext = createContext(null);
ComposerPluginContext.displayName = 'ComposerPluginContext';
/** Wraps a placement so its component's `usePlugin()` resolves to this context. */
export const PluginContextProvider = ComposerPluginContext.Provider;
//# sourceMappingURL=pluginContext.js.map